import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { IonContent, useIonViewWillEnter } from '@ionic/react';
import { Formik } from 'formik';

import { screen } from '$gcomponents/hoc';
import { Header } from '$gcomponents/widgets';
import { input } from '$gbusiness/helpers';
import { IonPageWrapper } from './styles';
import { PageWrapper } from '$gstyles/wrapper';
import { FormSection } from '$gcomponents/reusables';
import { NOTIFICATION_FORM } from './notificationForm';
import { Button, Text } from '$gcomponents/primitives';
import StoreModel from '$fbusiness/models/store';
import Footer from '$gcomponents/widgets/footer';
import { factoryActions } from '$fbusiness/redux/factory';
import { storeActions } from '../../../factory/business/redux/store';
import AttachmentForm from '$fcomponents/contactForm/attachmentForm';
import { fileActions } from '$fbusiness/redux/file';
import { accessDisable, getAccess } from '$fbusiness/helpers/util';

interface NotificationScreenProps {
  emailNotification;
  factory;
  resetFinished;
  currentState;
  isFinished: boolean;
  addFiles;
  stores: Array<StoreModel>;
}

const NotificationScreen: React.FC<NotificationScreenProps> = ({
  stores,
  factory,
  addFiles,
  currentState,
  resetFinished,
  isFinished,
  emailNotification,
}) => {
  const notificationForm = NOTIFICATION_FORM(stores);
  const formRef = useRef<any>();
  const [files, setFiles] = useState<Array<any>>([]);
  const [overMax, setOverMax] = useState(false);

  const ACCESS = getAccess(currentState);

  useIonViewWillEnter(() => {
    clearForm();
  });

  useEffect(() => {
    if (!isFinished) return;
    resetFinished();
    clearForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFinished]);

  const clearForm = () => {
    formRef.current.resetForm();
  };

  const onChangeAttachment = (newFiles, isOver) => {
    setFiles(newFiles);
    setOverMax(isOver);
  };

  const onSubmit = async (values, formik) => {
    const param = {
      ...values,
      body: values.body.replace(/\n/g, '<br>'),
    };
    if (files.length) {
      const fileResult = await addFiles(files, 'broadcast');
      if (fileResult[0]) param.files = fileResult[0];
    }
    const result = await emailNotification(param);
    if (result) {
      formik.resetForm();
      setFiles([]);
    }
  };

  const validateForm = (values) => input.validateError(notificationForm, values);

  return (
    <IonPageWrapper>
      <Header title="SCREEN.NOTIFICATION.TITLE" />
      <Formik
        innerRef={formRef}
        enableReinitialize={true}
        initialValues={{
          from: factory.name,
          stores: [],
          subject: '',
          email: factory.email,
          body: '',
        }}
        validate={validateForm}
        onSubmit={(values, formik) => {
          onSubmit(values, formik);
        }}>
        {(formik) => {
          const isFormValid = formik.isValid && !overMax;
          return (
            <>
              <IonContent>
                <PageWrapper maxWidth="800px">
                  <FormSection FORM={notificationForm} formik={formik} />
                  <AttachmentForm className="attachform" files={files} onChange={onChangeAttachment} />
                </PageWrapper>
              </IonContent>
              <Footer justifyContent="space-around">
                <Button className="third" variant="outlined" onClick={clearForm}>
                  <Text k="BUTTON.CANCEL" />
                </Button>
                <Button
                  className={`half ${accessDisable(ACCESS.ACTION.EMAIL_NOTIFICATION)}`}
                  onClick={formik.handleSubmit}
                  disabled={!isFormValid}>
                  <Text k="BUTTON.SUBMIT" />
                </Button>
              </Footer>
            </>
          );
        }}
      </Formik>
    </IonPageWrapper>
  );
};

const mapStateToProps = (state) => ({
  isFinished: state.factory.isFinished,
  stores: state.store.stores,
  factory: state.factory.factory,
});

const mapDispatchToProps = {
  onHydrate: storeActions.fetchStores,
  emailNotification: factoryActions.emailNotification,
  addFiles: fileActions.addFiles,
  resetFinished: factoryActions.resetFinished,
};

const connected = connect(mapStateToProps, mapDispatchToProps);

export default connected(screen(NotificationScreen));
